import React, { MouseEventHandler, useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import ReactFlagsSelect from "react-flags-select"
import { useTranslation } from "react-i18next"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/style.css"
import api from "../../api"

const UpdateAddressModal = ({
    show,
    customer,
    loading,
    selectedAddress,
    setSelectedAddress,
    handleClose,
    handleSubmit
}: {
    show: string
    customer: Record<string, any>
    loading: boolean
    selectedAddress: Record<string, any>
    setSelectedAddress: Function
    handleClose: () => void
    handleSubmit: Function
}) => {
    const { t, i18n } = useTranslation()

    const [cities, setCities] = useState([] as Record<string, any>[])

    const loadCities = async (countryCode: string) => {
        try {
            const res = await api.customer.loadCities(countryCode)

            if (res?.data?.status) {
                setCities(res?.data?.payload?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (selectedAddress?.country) {
            loadCities(selectedAddress?.country)
        } else {
            setSelectedAddress({ ...selectedAddress, country: "AE" })
            loadCities("AE")
        }
    }, [selectedAddress?.country])

    useEffect(() => {
        if (
            customer?.user_addresses?.length > 0 &&
            customer?.user_addresses?.find((record: Record<string, any>) => record?.is_primary)?.id
        ) {
            setSelectedAddress({
                ...customer?.user_addresses?.find((record: Record<string, any>) => record?.is_primary)
            })
        }
    }, [customer?.user_addresses?.length])

    return (
        <Modal
            show={show === "updateAddressModal"}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={"gray-bg"}
            centered>
            <Modal.Header className="mx-2" closeButton>
                <Modal.Title>{t("Update user address")}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 mb40 mt-3 py-0">
                <Form>
                    {customer?.user_addresses?.length > 0 && (
                        <Row>
                            <Col lg={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label htmlFor="selectedAddress">
                                        {t("Update Customer Address")}
                                    </Form.Label>
                                    <Form.Select
                                        id="selectedAddress"
                                        name={"selectedAddress"}
                                        defaultValue={selectedAddress?.id}
                                        value={selectedAddress?.id}
                                        onChange={(e: any) => {
                                            setSelectedAddress({
                                                ...customer?.user_addresses?.find(
                                                    (userAddress: Record<string, any>) =>
                                                        userAddress?.id?.toString() === e.target.value
                                                ),
                                                user_id: customer?.id
                                            })
                                        }}
                                        placeholder="Group name...">
                                        <option>{t("Select a user address")}</option>
                                        {customer?.user_addresses?.map((userAddress: Record<string, any>) => (
                                            <option value={userAddress?.id}>
                                                {`${userAddress?.address}, ${userAddress?.address2}, ${userAddress?.city}, ${userAddress?.country}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="fname">{t("First Name")}</Form.Label>
                                <Form.Control
                                    value={selectedAddress?.fname}
                                    id="fname"
                                    type={"text"}
                                    name={"fname"}
                                    autoComplete="off"
                                    onChange={(e: any) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            [e.target.name]: e.target.value
                                        })
                                    }}
                                    placeholder="User First Name..."
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="lname">{t("Last Name")}</Form.Label>
                                <Form.Control
                                    value={selectedAddress?.lname}
                                    id="lname"
                                    type={"text"}
                                    name={"lname"}
                                    autoComplete="off"
                                    onChange={(e: any) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            [e.target.name]: e.target.value
                                        })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="country">{t("Country")}</Form.Label>
                                <ReactFlagsSelect
                                    id="country"
                                    // countries={countries?.map(country => country.iso2_code)}
                                    // className={`${i18n.language === "ar" && "rtl-direction"}`}
                                    selected={selectedAddress?.country || "AE"}
                                    showSelectedLabel
                                    placeholder={"Select a country"}
                                    alignOptionsToRight
                                    fullWidth
                                    onSelect={(code) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            country: code
                                        })
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="city">{t("State")}</Form.Label>
                                <Form.Select
                                    id="addressCity"
                                    name={"city"}
                                    value={
                                        cities?.find(
                                            (city: Record<string, any>) => city?.id === selectedAddress.city_id
                                        )?.id
                                    }
                                    onChange={(e: any) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            city_id: Number(e.target.value),
                                            city: cities.find(
                                                (city: Record<string, any>) =>
                                                    city?.id === Number(e.target.value)
                                            )?.state_name
                                        })
                                    }}
                                    placeholder="Group name...">
                                    <option>{t("Select a city")}</option>
                                    {cities?.map((city: Record<string, any>) => (
                                        <option value={city?.id}>{city?.state_name}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col lg={6}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="Phone">{t("Phone no.")}</Form.Label>
                                <PhoneInput
                                    country={
                                        (selectedAddress?.country &&
                                            selectedAddress?.country?.toLocaleLowerCase()) ||
                                        "ae"
                                    }
                                    inputProps={{
                                        name: "phone",
                                        autoComplete: "off"
                                    }}
                                    disableCountryCode={true}
                                    enableAreaCodes={false}
                                    onChange={(phoneValue) =>
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            phone: phoneValue
                                        })
                                    }
                                    inputClass="form-control w-100"
                                    value={selectedAddress?.phone}
                                    //containerClass={classNameForPhoneInput}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="address1">{t("Address Line 1")}</Form.Label>
                                <Form.Control
                                    value={selectedAddress?.address}
                                    id="address1"
                                    type={"text"}
                                    name={"address"}
                                    autoComplete="off"
                                    onChange={(e: any) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            [e.target.name]: e.target.value
                                        })
                                    }}
                                    placeholder="Address Line 1..."
                                />
                            </Form.Group>
                        </Col>
                        <Col lg={12}>
                            <Form.Group className="mb-3">
                                <Form.Label htmlFor="address">{t("Address Line 2")}</Form.Label>
                                <Form.Control
                                    value={selectedAddress?.address2}
                                    id="address2"
                                    type={"text"}
                                    name={"address2"}
                                    autoComplete="off"
                                    onChange={(e: any) => {
                                        setSelectedAddress({
                                            ...selectedAddress,
                                            [e.target.name]: e.target.value
                                        })
                                    }}
                                    placeholder="Address Line 2..."
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose as MouseEventHandler<HTMLButtonElement>}>
                    {t("Close")}
                </Button>
                {loading ? (
                    <div className="spinner-border text-primary" role="status"></div>
                ) : (
                    <Button
                        onClick={() => {
                            if (selectedAddress?.id) {
                                handleSubmit(selectedAddress?.id)
                            } else {
                                handleSubmit(null, customer?.id)
                            }
                        }}
                        className="btn btn-primary"
                        type="submit">
                        {selectedAddress?.id ? t("Update Address") : t("Add Address")}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateAddressModal
